import React from "react";
import styled from "styled-components";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import icon from "@fortawesome/fontawesome-free-regular/faSquare";
import caretDown from "@fortawesome/fontawesome-free-solid/faCaretDown";
import Button from "../../UI/Button/Button";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default class Filters extends React.Component {
  constructor(props) {
    super(props);
    this.title = this.props.title;
    this.properties = this.props.properties;
    this.limit = 5;
    this.state = { limit: this.limit, children: this.getChildren() };
  }

  getChildren() {
    let temp = [];
    this.properties.map((property, i) => temp.push(false));
    return temp;
  }

  toggleLimit() {
    let limit;
    this.limit === this.state.limit ? (limit = 999) : (limit = this.limit);
    this.setState({ limit });
  }

  toggleChild(i) {
    let children = this.state.children;
    children[i] = !children[i];
    this.setState({ children });
  }

  render() {
    return (
      <PropertyList>
        {this.state.children}
        <PropertyTitle>{this.title}</PropertyTitle>
        {this.title != "Date" ? (
          <div>
            {this.properties.map((property, i) => (
              <div>
                {i < this.state.limit ? (
                  <div>
                    <Property key={i}>
                      <Checkbox icon={icon} /> {property.name}{" "}
                      <Size>{property.size}</Size>
                    </Property>
                    {property.children ? (
                      <ChildrenProperties>
                        <Button size="xs" onClick={() => this.toggleChild(i)}>
                          <FontAwesomeIcon icon={caretDown} />
                        </Button>
                        {this.state.children[i]
                          ? property.children.map((child, j) => (
                              <div>
                                <Property key={j}>
                                  <Checkbox icon={icon} /> {child.name}{" "}
                                  <Size>{child.size}</Size>
                                </Property>
                              </div>
                            ))
                          : ""}
                      </ChildrenProperties>
                    ) : (
                      false
                    )}
                  </div>
                ) : (
                  false
                )}{" "}
              </div>
            ))}
            {this.properties.length > this.limit ? (
              <Button size="xs" onClick={() => this.toggleLimit()}>
                <FontAwesomeIcon
                  icon={caretDown}
                  style={{ marginRight: 7, marginLeft: 1 }}
                />{" "}
                Show more
              </Button>
            ) : (
              false
            )}
          </div>
        ) : (
          ""
        )}
        {this.title === "Date" ? (
          <PropertyDate>
            <DatePicker placeholderText="From DD/MM/YYYY" />
            <span>-</span>
            <DatePicker placeholderText="To DD/MM/YYYY" />
          </PropertyDate>
        ) : (
          ""
        )}
      </PropertyList>
    );
  }
}

const PropertyList = styled.dl`
  width: 100%;
  padding-right: 16px;
`;

const PropertyTitle = styled.dt`
  margin-bottom: 8px;
`;

const Property = styled.dd`
  line-height: 1.2em;
  padding: 5px;
  margin: 0;
`;

const PropertyDate = styled.div`
  display: flex;

  span {
    display: block;
    width: 6%;
    text-align: center;
    line-height: 25px;
  }
  input {
    width: 100%;
  }
`;

const ChildrenProperties = styled.div`
  position: relative;
  padding-left: 20px;

  ${Button} {
    position: absolute;
    top: -25px;
    right: -25px;
  }
`;

const Size = styled.span`
  float: right;
`;

const Checkbox = styled(FontAwesomeIcon)`
  color: #aeaeb8;
  margin-right: 5px;
`;



// WEBPACK FOOTER //
// ./src/UI/Filters/Filters.js